import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, captionClassName } from '@archipro-design/aria';

export const TestimonialSlideWrapper: StyleRule = ({ theme }) => ({
    userSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    flexDirection: 'column',
    width: 'inherit',
    [theme.screen.laptop]: {
        borderTop: `2px solid ${theme.siteVariables.colors.charcoal[250]}`,
        paddingTop: pxToRem(36),
    },
});

const MAX_TESTIMONIAL_LINE_NUMBER = 10;
const MAX_TESTIMONIAL_LINE_NUMBER_MOBILE = 7;
const MAX_SOURCES_LINE_NUMBER = 2;

export const TestimonialSlideContent: StyleRule = ({ theme }) => ({
    flexDirection: 'column',
    lineHeight: pxToRem(18),
    scrollbarColor: `${theme.siteVariables.colors.grey[200]} transparent`,
    maxHeight: pxToRem(16 * 1.3 * MAX_TESTIMONIAL_LINE_NUMBER_MOBILE),
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    '& > *': {
        marginBottom: pxToRem(16),
        marginTop: 0,
    },
    '&::-webkit-scrollbar': {
        width: pxToRem(5),
        marginRight: pxToRem(5),
    },

    '&::-webkit-scrollbar-thumb': {
        backgroundColor: `${theme.siteVariables.colors.grey[200]}`,
        borderRadius: pxToRem(10),
    },

    '& a': {
        color: `inherit`,
        textDecoration: `underline`,

        '&:hover': {
            color: `${theme.siteVariables.colors.charcoal['000']}`,
        },
    },
    '& p:last-child': {
        marginBottom: 0,
    },
    marginRight: pxToRem(2),
    [`&.${captionClassName}`]: {
        fontSize: theme.siteVariables.fontSizes.caption04,
        lineHeight: 1.5,
    },
    [theme.screen.laptop]: {
        flexDirection: 'row',
        lineHeight: theme.siteVariables.lineHeightSmall,
        [`&.${captionClassName}`]: {
            fontSize: theme.siteVariables.fontSizes.caption03,
        },
        letterSpacing: 0,
        marginBottom: 0,
        paddingRight: pxToRem(40),
        marginRight: pxToRem(10),
        overflowY: 'auto',
        maxHeight: pxToRem(16 * 1.3 * MAX_TESTIMONIAL_LINE_NUMBER),
    },
});

export const TestimonialSource: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(24),
    lineHeight: pxToRem(18),
    '& > *': {
        marginBottom: 0,
    },
    WebkitLineClamp: MAX_SOURCES_LINE_NUMBER,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    [theme.screen.laptop]: {
        marginTop: pxToRem(11),
        lineHeight: pxToRem(34),
    },
});

export const TestimonialSourceMobile: StyleRule = ({ theme }) => ({
    ...TestimonialSource({ theme }),
    flexDirection: 'column',
    letterSpacing: 0,
    [`&.${captionClassName}`]: {
        fontWeight: 500,
    },
});
